import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RandomContent from '../Components/RandomContent';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GetPageContentBySlug } from '../services/apiservice';
import { useLocation } from 'react-router-dom';

const UuidGenerator = () => {
  const [count, setCount] = useState(1);
  const [uuids, setUuids] = useState([]);
  const [pageContent, setPageContent] = useState('');
  const location = useLocation();

  const paramlink = location.pathname.split("/").filter(Boolean).pop();

  useEffect(() => {
    fetchPageContent();
  }, []);

  const fetchPageContent = async () => {
    if (paramlink !== undefined && paramlink !== "") {
      try {
        const postMetaList = await GetPageContentBySlug(paramlink);
        const jsonMetaList = JSON.parse(postMetaList);
        setPageContent(jsonMetaList);
        console.log(jsonMetaList);
      } catch (error) {
        console.error('Error fetching the meta data:', error);
      }
    }
  };

  const generateUUID = () => {
    const newUuids = [];
    const num = Math.max(1, parseInt(count) || 1);

    for (let i = 0; i < num; i++) {
      newUuids.push(
        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        })
      );
    }
    setUuids(newUuids);
  };

  const handleClear = () => {
    setCount(1);
    setUuids([]);
  };

  const handleCopyAll = () => {
    navigator.clipboard.writeText(uuids.join('\n'));
    toast.success('Copied all UUIDs!', { position: "top-right", autoClose: 2000 });
  };

  const handleCopy = (uuid) => {
    navigator.clipboard.writeText(uuid);
    toast.success('Copied!', { position: "top-right", autoClose: 2000 });
  };

  return (
    <>
      <Header />

      <RandomContent />

      {/* Page Intro (Section 1) */}
      <div className="blog-area">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-12 col-md-12">
              <div className="single-blog-inner shadow-sm p-4 mb-4" data-aos="fade-up" data-aos-duration="2800">
                <div className="details">
                  <h4><a href="#">{pageContent?.section1header}</a></h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        pageContent?.section1text && pageContent.section1text.trim() !== ""
                          ? pageContent.section1text
                          : `Generate unique UUIDs instantly. Copy all UUIDs at once or copy individual UUIDs using the icon. Perfect for testing, development, or placeholder identifiers. 🚀`,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Generator Section */}
      <div className="blog-area pb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-6 col-md-8">
              <div className="single-blog-inner p-5 shadow-lg rounded-3" data-aos="fade-up" data-aos-duration="2800">

                {/* Controls */}
                <div className="mb-3">
                  <label className="form-label">Number of UUIDs</label>
                  <input
                    type="number"
                    className="form-control"
                    min="1"
                    max="50"
                    value={count}
                    onChange={(e) => setCount(e.target.value)}
                  />
                </div>

                {/* Buttons */}
                <div className="d-flex gap-2 mb-3 generator-buttons">
                  <button className="default-btn icon four" onClick={generateUUID}>Generate</button>
                  <button className="default-btn icon outline" onClick={handleClear}>Clear</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fullscreen Output Section */}
      {uuids.length > 0 && (
        <div className="uuid-output-area py-5 bg-light">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-10 col-md-12">
                <div className="single-blog-inner p-4 shadow-sm rounded-3">
                  {/* Top Copy All Button */}
                  <div className="d-flex justify-content-end mb-3">
                    <button className="btn btn-outline-secondary btn-sm" onClick={handleCopyAll} title="Copy All UUIDs">
                      <i className="ri-file-copy-line"></i>
                    </button>
                  </div>

                  {/* UUID List */}
                  <div className="uuid-list">
                    {uuids.map((uuid, idx) => (
                      <div key={idx} className="uuid-item d-flex justify-content-between align-items-center mb-2 p-2 rounded bg-white shadow-sm">
                        <span className="uuid-text">{uuid}</span>
                        <button
                          className="btn btn-sm btn-outline-secondary ms-2"
                          onClick={() => handleCopy(uuid)}
                          title="Copy UUID"
                        >
                          <i className="ri-file-copy-line"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Section 2 Below Boxes */}
      {pageContent?.section2text && pageContent.section2text.trim() !== "" && (
        <div className="blog-area">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-12 col-md-12">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                  <div className="details">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: pageContent.section2text,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Section 3 Below Boxes */}
      {pageContent?.section3text &&
        pageContent.section3text.trim() !== "" && (
          <div className="blog-area">
            <div className="container-block-fluid">
              <div className="row justify-content-center">
                <div className="full-col col-lg-12 col-md-12">
                  <div
                    className="single-blog-inner"
                    data-aos="fade-up"
                    data-aos-duration="2800"
                  >
                    <div className="details">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pageContent.section3text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      <Footer />
      <ToastContainer />
    </>
  );
};

export default UuidGenerator;
